module.exports = __webpack_public_path__ + "posture/static/img/spine_sideway_left.c13ffd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/normal/spine_sideway_left.png
// module id = xHUF
// module chunks = 1